<cc-template-field-settings
  *ngIf="fieldSettingsActions.length > 0"
  [field]="field"
  [actions]="fieldSettingsActions"
></cc-template-field-settings>
<cc-banner
  *ngIf="hasRequiredField"
  icon="arrow-long-left"
  size="sm"
  class="required-control-banner"
  customClasses="no-container-padding !sm-px-1 !sm-py-[2px]"
  [bannerText]="requiredBannerText"
  [localStorageKey]="requiredBannerStorageKey"
  [bannerKey]="requiredBannerKey"
  ccBannerLogic
></cc-banner>
<cc-field-action type="delete" (onClick)="fieldActionsConfig.delete.onUpdate.emit()"></cc-field-action>
<cc-field-action
  type="clone"
  [disabled]="disabled"
  (onClick)="fieldActionsConfig.clone.onUpdate.emit()"
></cc-field-action>
